import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import TemplateEditModalContainer from './TemplateEditModalContainer';
import {templateType} from '../../constants/proptype-validation';
import {parseTemplateToPendingTemplateForm} from '../../utils/issue-template-helpers';
import lodashMemoize from 'lodash/memoize';

class TemplateDuplicateModal extends PureComponent {
  onSaveSuccess = () => {
    this.props.showNotificationAction({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: i18n.t('templatesGrid.newModal.createdMessage')
    });

    // Unhighlight the newly added template in the table after X seconds.
    setTimeout(() => {
      this.props.resetTemplatesHighlightingRowsAction();
    }, 3000);
  };

  onSaveError = () => {
    this.props.showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: i18n.t('templatesGrid.newModal.errorMessage')
    });
  };

  closeModal = () => {
    this.props.setDuplicateTemplateIdAction(null);
  };

  getFormValuesFromTemplate = lodashMemoize(previewTemplate => parseTemplateToPendingTemplateForm(previewTemplate));

  render() {
    const {container, duplicateTemplateId, duplicateTemplate} = this.props;
    return (
      <TemplateEditModalContainer
        isOpen={!!duplicateTemplateId}
        title={i18n.t('templatesGrid.newModal.title')}
        saveButtonText={i18n.t('new.create')}
        savingButtonText={i18n.t('new.creating')}
        container={container}
        initialValues={this.getFormValuesFromTemplate(duplicateTemplate)}
        onClose={this.closeModal}
        onSaveSuccess={this.onSaveSuccess}
        onSaveError={this.onSaveError}
      />
    );
  }
}

TemplateDuplicateModal.displayName = 'TemplateDuplicateModal';

TemplateDuplicateModal.propTypes = {
  duplicateTemplateId: PropTypes.string,
  duplicateTemplate: templateType,
  container: PropTypes.object,
  setDuplicateTemplateIdAction: PropTypes.func.isRequired,
  resetTemplatesHighlightingRowsAction: PropTypes.func.isRequired,
  showNotificationAction: PropTypes.func.isRequired
};

export default TemplateDuplicateModal;
